import { API } from "@/lib/api";

const SID_KEY = "ba30_sid";
const UTM_KEY = "ba30_utm";

function sessionId() {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem(SID_KEY, s); }
  return s;
}

export function captureUtm() {
  const q = new URLSearchParams(window.location.search);
  const utm = {};
  q.forEach((v, k) => { if (k.startsWith("utm_")) utm[k] = v; });
  if (Object.keys(utm).length) sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
}

export function getUtm() {
  try { return JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
}

// Appends session + utm to the Stripe Payment Link so purchase_membership can be attributed server-side.
export function attributedCheckoutUrl(base) {
  if (!base) return base;
  const u = new URL(base);
  u.searchParams.set("client_reference_id", sessionId());
  Object.entries(getUtm()).forEach(([k, v]) => u.searchParams.set(k, v));
  return u.toString();
}

export function track(event, props = {}) {
  const payload = {
    event, props, session_id: sessionId(),
    path: window.location.pathname, referrer: document.referrer || null, utm: getUtm(),
  };
  if (typeof window.gtag === "function") window.gtag("event", event, { ...props, ...getUtm() });
  try {
    fetch(`${API}/events`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  } catch { /* never block UI on analytics */ }
}

// Any element with data-event="..." fires that event on click (data-cta-location becomes props.location).
export function bindClickTracking() {
  const handler = (e) => {
    const el = e.target.closest?.("[data-event]");
    if (!el) return;
    track(el.dataset.event, { location: el.dataset.ctaLocation || el.dataset.testid || null, href: el.getAttribute("href") });
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}
